import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/global.css'; // Importar o CSS global
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
